<template>
    <nav class="navigation navigation--main">
        <div class="container-fluid">
            <Logo />
            <ul class="menu">
                <li
                    class="account has-dropdown"
                    @mouseover="showDropdown(true)"
                    @mouseleave="hideDropdown(true)"
                    @click="showDropdown(false)">
                    <div
                        v-if="$page.auth.user.image"
                        class="thumb">
                        <figure class="object-cover">
                            <img
                                v-if="$page.auth.user.image"
                                :src="`/storage/${$page.auth.user.image}`"
                                alt="">
                        </figure>
                    </div>
                    <div>
                        <span>Mijn account</span>
                    </div>

                    <i class="ml-1 i-chevron-down"></i>

                    <Dropdown ref="dropdown">
                        <li v-b-modal.profile-settings><span>Profiel</span></li>

                        <li>
                            <inertia-link
                                class="nav-link"
                                href="/nl/logout"
                                method="post"
                            >
                                <span>Uitloggen</span>
                            </inertia-link></li>
                    </Dropdown>
                </li>
            </ul>
        </div>

        <CoreModal
            id="profile-settings"
            title="Mijn profiel instellingen">
            <EditAccount />
        </CoreModal>
    </nav>
</template>

<script>
import Logo from '../Brand/Logo.vue'
import Dropdown from './Dropdown.vue'
import EditAccount from '../Form/EditAccount.vue'

export default {
    components: {
        Logo,
        Dropdown,
        EditAccount
    },
    props: {
        view: {
            type: String,
            default: 'user'
        }
    },
    methods: {
        showDropdown(responsive) {
            if (responsive && window.innerWidth > 767) {
                this.$refs.dropdown.isVisible = true
            } else if(!responsive) {
                this.$refs.dropdown.isVisible = true
            }
        },
        hideDropdown(responsive) {
            if (responsive && window.innerWidth > 767) {
                this.$refs.dropdown.isVisible = false
            } else if(!responsive) {
                this.$refs.dropdown.isVisible = false
            }

        }
    }
}
</script>

<style lang="scss" scoped>
nav {
    position: relative;
    z-index: 1000;

    &.fixed {
        position: fixed;
        top: 0;
        width: 100%;
        margin-bottom: 2rem;
    }

    .container,
    .container-fluid {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 75px;
    }

    .container-fluid {
        padding: 0 2rem;
    }

    ul.menu {
        display: flex;

        & > li {
            display: flex;
            align-items: center;
            margin: 1rem;

            &.has-dropdown {
                @include breakpoint(md) {
                    position: relative;
                }
            }

            &.account {
                // color: var(--text-dark);
                font-weight: bold;

                .thumb {
                    position: relative;
                    width: 40px;
                    height: 40px;
                    margin-right: 1rem;
                    border-radius: 50%;
                    background-color: var(--grey-25);

                    .object-cover {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        border-radius: 50%;
                        object-fit: cover;
                    }

                    .count {
                        display: inline-flex;
                        position: absolute;
                        top: -5px;
                        right: -5px;
                        flex-shrink: 0;
                        align-items: center;
                        justify-content: center;
                        width: 18px;
                        height: 18px;
                        border-radius: 50%;
                        background-color: var(--system-red);
                        color: #fff;
                        font-size: 0.75rem;
                        font-weight: bold;
                    }
                }

                strong,
                i {
                    display: none;

                    @include breakpoint(md) {
                        display: block;
                    }
                }

                .thumb + strong {
                    margin: 0 1rem;
                }

                i {
                    color: var(--primary);
                }
            }
        }
    }
}
</style>
